/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

export default () => {
  const { getBalance } = actions;
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  return useEffect(() => {
    if (authReducer.isLogin) {
      dispatch(getBalance());
    }
  }, [dispatch, authReducer.isLogin]);
};
